import React from "react";
import { useNavigate } from "react-router-dom";
import { SideMenuList } from "../../utils/constants";
import { useProductsContext } from "../../Contexts/SidebarContext";
import { useMediaQuery } from "react-responsive";

function SideMenu({ menu }: any) {
  const navigate = useNavigate();
  const { sideBar, setSubscriber, menuTab, setMenuTab } = useProductsContext();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const broadcast: any = localStorage.getItem("broadcastConnection");
  let filteredMenu = SideMenuList;

  if (broadcast === "marketing-message") {
    filteredMenu = SideMenuList.filter(
      (item: any) =>
        item.menu === "dmcampaigns" || item.menu === "customaudiences",
    );
  } else {
    filteredMenu = SideMenuList.filter(
      (item: any) =>
        item.menu !== "dmcampaigns" || item.menu !== "customaudiences",
    );
  }

  const handleMenu = (menuItem: any) => {
    if (menuItem === "templates" || menuItem === "instatemplates") {
      setMenuTab("");
    }
    setSubscriber("");
    navigate(`/dashboard/${menuItem}`);
  };

  return (
    <div className="opensidemenu">
      <div
        className="left-side-menu"
        style={{
          width: sideBar ? "220px" : isMobile ? "0px" : "80px",
        }}>
        <div id="sidebar-menu">
          <ul className="metismenu" id="side-menu">
            {filteredMenu.map((menuItem: any, index: any) => {
              const selectedConnection: any =
                localStorage.getItem("activeConnection");
              if (menuItem?.connectiontype) {
                if (
                  menuItem?.connectiontype?.indexOf(selectedConnection) === -1
                )
                  return null;
              }
              const isActive = menu === menuItem?.menu;
              const isChatbotMode = menuTab === "chatbot";
              const isSubscribersActive =
                (menuTab === "chatbot" && menuItem?.menu === "subscribers") ||
                (menuTab === "chatbot1" && menuItem?.menu === "optinfollowup");
              const isSubscribersActive1 =
                (menuTab === "fbTemp" && menuItem?.menu === "templates") ||
                (menuTab === "instaTemp" &&
                  menuItem?.menu === "instatemplates");
              return (
                <React.Fragment key={index}>
                  <li
                    key={index}
                    onClick={() => {
                      handleMenu(menuItem?.menu);
                    }}>
                    <p
                      className={`waves-effect waves-light anchor-tag ${
                        isActive ? "active" : ""
                      } 
                      ${isChatbotMode ? "chatbot-active" : ""} 
                      ${isSubscribersActive ? "subscribers-active" : ""}`}
                      style={{
                        display: menuItem?.menu === "chatbot" ? "none" : "",
                      }}>
                      {isMobile ? "" : <i className={`${menuItem?.icon}`}></i>}
                      <span style={{ display: sideBar ? "block" : "none" }}>
                        {" "}
                        {isMobile ? (
                          <i className={`${menuItem?.icon}`}></i>
                        ) : (
                          ""
                        )}
                        {menuItem?.label}{" "}
                      </span>
                    </p>
                  </li>
                  {isSubscribersActive1 && (
                    <li
                      className="nested-menu"
                      onClick={() => handleMenu("chatbot")}
                      style={{
                        display:
                          menuItem?.menu === "chatbot" ||
                          menuItem?.menu === "subscribers"
                            ? "none"
                            : "",
                        pointerEvents: "none",
                      }}>
                      <p
                        className={`waves-effect waves-light anchor-tag nested ${
                          isSubscribersActive1 ? "active" : ""
                        }`}>
                        {!isMobile && <i className="icon-chatbot"></i>}
                        {sideBar && (
                          <span>
                            {isMobile && <i className="icon-chatbot"></i>}
                            <i
                              className="fas fa-robot"
                              style={{ marginBottom: "5px" }}></i>
                            ChatBot Tool
                          </span>
                        )}
                      </p>
                    </li>
                  )}
                </React.Fragment>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}
export default SideMenu;
